export default __webpack_public_path__ + "static/media/logo.b751f65d.jpg";